import { formatBalanceWithCommas, formatCryptoPrice, formatTextEllipsis, formatTimeAgo, formatValueWithCompactNumber } from '@/lib/format';
import { cn } from '@/lib/utils';
import { ITokenActivity } from '@/request/token/token.response.interface';
import { useAppStore } from '@/store';
import BigNumber from 'bignumber.js';

interface IProps {
  activity: ITokenActivity;
}
export default (props: IProps) => {
  const { activity } = props;
  const { lang } = useAppStore();
  const isTradeBuy = activity.type == 'buy';
  const tradeTypeColor = isTradeBuy ? 'bg-[#3CDEA54D] text-[#3CDEA5]' : 'bg-[#FF6D6D4D] text-[#FF6D6D]';
  const textColor = isTradeBuy ? 'text-buyColor' : 'text-sellColor';
  const totalUsd = BigNumber(activity.price).times(activity.amount).toString();

  const amount = BigNumber(activity.amount).gt(1) ? formatValueWithCompactNumber(activity.amount) : formatCryptoPrice(activity.amount);

  return (
    <div className="flex items-center text-[12px] h-[72px] border-b-[1px] border-borderColor">
      <div className="flex-1">
        <div className="flex gap-x-[4px] mb-[4px]">
          <span className={cn('text-[12px] px-[6px] rounded-[6px]', tradeTypeColor)}>{isTradeBuy ? 'Buy' : 'Sell'}</span>
          <span className={cn(textColor)}>{(isTradeBuy ? '+' : '-') + amount}</span>
        </div>
        <p className="text-secondaryTextColor">{formatTimeAgo(activity.lastActiveTime, { style: 'shortAgo', lang })}</p>
      </div>
      <div className="text-right flex-1">
        <p className="">{formatBalanceWithCommas(totalUsd)}</p>
        <p className="text-secondaryTextColor">${formatCryptoPrice(activity.price)} </p>
      </div>
      <div className="text-right flex-1">{formatTextEllipsis(activity.walletAddress)}</div>
    </div>
  );
};
